module.exports = __webpack_public_path__ + "img/vote-10@2x.821ac279.png";